 "use strict";

var React = require('react/addons');
var Fluxxor = require('fluxxor');
var _ = require('underscore');

var moment = require('ofs/moment');


var DateStore = Fluxxor.createStore({
  actions: {
    CHANGE_PAGE_DATE_RANGE: 'onDateRangeChange'
  },

  initialize: function (options) {
    this.setMaxListeners(0);
    this.state = _.clone(options);
    if (this.state.startDate) {
      this.state.startDate = moment(this.state.startDate);
    }
    if (this.state.endDate) {
      this.state.endDate = moment(this.state.endDate);
    }
    if (this.state.startDate && this.state.endDate) {
      this.state.range = moment().range(this.state.startDate, this.state.endDate);
    }
  },

  onDateRangeChange: function(payload) {
    var range = payload.range;

    this.state = React.addons.update(this.state, {
      range: {$set: range},
      startDate: {$set: range.start},
      endDate: {$set: range.end}
    });
    this.emit('change');
  },

  getState: function () {
    return this.state;
  },

  getFormattedStartDate: function() {
    if (this.state.range) {
      return this.state.range.start.format('D MMMM YYYY');
    }
    return null;
  },

  getFormattedEndDate: function() {
    if (this.state.range) {
      return this.state.range.end.format('D MMMM YYYY');
    }
    return null;
  },

  getISO8601StartDate: function() {
    if (this.state.range) {
      return this.state.range.start.format('YYYY-MM-DD');
    }
    return null;
  },

  getISO8601EndDate: function() {
    if (this.state.range) {
      return this.state.range.end.format('YYYY-MM-DD');
    }
    return null;
  }
});

module.exports = DateStore;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/stores/date.js
 **/